import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

export default function Cart() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const shipping = subtotal >= 150 || subtotal === 0 ? 0 : 12;
  const total = subtotal + shipping;

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16" data-testid="cart-page">
      <div className="bgc-eyebrow text-[#c8102e]">CHECKOUT</div>
      <h1 className="font-display text-6xl tracking-tight uppercase mt-3">Your Cart</h1>

      {items.length === 0 ? (
        <div className="mt-12 border border-white/10 p-12 text-center">
          <p className="font-display text-2xl tracking-wider uppercase">EMPTY GARAGE</p>
          <p className="text-[#9ca3af] mt-2">You have not added anything yet.</p>
          <Link to="/shop" className="btn-primary mt-8 inline-flex" data-testid="cart-empty-shop">
            SHOP NOW
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mt-12">
          <div className="lg:col-span-2 space-y-4">
            {items.map((it, idx) => (
              <div key={idx} className="flex gap-5 border border-white/10 p-5 bg-[#0a0a0a]" data-testid={`cart-row-${idx}`}>
                {it.image && <img src={it.image} alt={it.name} className="w-28 h-28 object-cover border border-white/10" />}
                <div className="flex-1">
                  <p className="font-display text-lg tracking-wider uppercase">{it.name}</p>
                  {it.variant && (
                    <p className="text-xs text-[#9ca3af] mt-1">
                      {Object.entries(it.variant).map(([k, v]) => `${k}: ${v}`).join(" · ")}
                    </p>
                  )}
                  <p className="text-[#c8102e] font-semibold mt-2">${it.price.toFixed(2)}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <div className="flex items-center border border-white/20">
                      <button onClick={() => updateQty(idx, it.quantity - 1)} className="p-2 hover:bg-white/5" data-testid={`row-${idx}-dec`}><Minus className="w-3 h-3" /></button>
                      <span className="px-4 text-sm">{it.quantity}</span>
                      <button onClick={() => updateQty(idx, it.quantity + 1)} className="p-2 hover:bg-white/5" data-testid={`row-${idx}-inc`}><Plus className="w-3 h-3" /></button>
                    </div>
                    <button onClick={() => removeItem(idx)} className="text-[#9ca3af] hover:text-[#c8102e]" data-testid={`row-${idx}-remove`}>
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
                <p className="font-semibold whitespace-nowrap">${(it.price * it.quantity).toFixed(2)}</p>
              </div>
            ))}
          </div>

          <aside className="border border-white/10 p-6 h-fit bg-[#0a0a0a]">
            <h2 className="font-display text-2xl tracking-wider uppercase">Order Summary</h2>
            <div className="space-y-2 mt-5 text-sm">
              <div className="flex justify-between"><span className="text-[#9ca3af]">Subtotal</span><span data-testid="summary-subtotal">${subtotal.toFixed(2)}</span></div>
              <div className="flex justify-between"><span className="text-[#9ca3af]">Shipping</span><span>{shipping === 0 ? "FREE" : `$${shipping.toFixed(2)}`}</span></div>
              <div className="flex justify-between text-base pt-3 border-t border-white/10 mt-3"><span className="font-semibold">Total</span><span className="font-bold" data-testid="summary-total">${total.toFixed(2)}</span></div>
            </div>
            <Link to="/checkout" className="btn-primary w-full justify-center mt-6" data-testid="goto-checkout-button">
              CHECKOUT
            </Link>
            <Link to="/shop" className="btn-ghost w-full justify-center mt-3" data-testid="continue-shopping-button">
              CONTINUE SHOPPING
            </Link>
          </aside>
        </div>
      )}
    </div>
  );
}
